export const images = [
  'airplane.webp',
  'alien.webp',
  'canon.webp',
  'dog.webp',
  'dragon.webp',
  'eiffel-tower.webp',
  'guitar.webp',
  'headset.webp',
  'horse.webp',
  'microphone.webp',
  'phone.webp',
  'orc.webp',
  'palm-tree.webp',
  'tv.webp',
  'scooter.webp',
  'viking.webp',
];
